import script from "./RcdTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./RcdTabs.vue?vue&type=script&setup=true&lang=js"

import "./RcdTabs.vue?vue&type=style&index=0&id=2cdd0dd7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cdd0dd7"]])

export default __exports__